<app-header></app-header>
<app-loader></app-loader>
<div class="content-wrap">
<router-outlet></router-outlet>
</div>
<footer class="footer-container">
<app-footer class="noprint"></app-footer>
</footer>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
